// src/components/SystemRecommendation/components/ConfidenceBadge.tsx

import React from 'react';
import { ConfidenceScore } from '../types';

interface ConfidenceBadgeProps {
  confidence: ConfidenceScore;
  showPercentage?: boolean;
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({
  confidence,
  showPercentage = true
}) => {
  const getConfidenceColor = () => {
    switch (confidence.level) {
      case 'high':
        return '#34C759'; // Green
      case 'medium':
        return '#FF9500'; // Amber
      case 'low':
        return '#FF3B30'; // Red
      default:
        return '#8E8E93'; // Gray
    }
  };

  const getConfidenceIcon = () => {
    switch (confidence.level) {
      case 'high':
        return '✓✓✓';
      case 'medium':
        return '✓✓';
      case 'low':
        return '✓';
      default:
        return '?';
    }
  };

  // Map confidence levels to data completeness labels
  const getCompletenessLabel = () => {
    switch (confidence.level) {
      case 'high':
        return 'Complete';
      case 'medium':
        return 'Partial';
      case 'low':
        return 'Limited';
      default:
        return 'Unknown';
    }
  };

  return (
    <div
      className={`confidence-badge ${confidence.level}`}
      style={{ borderColor: getConfidenceColor() }}
    >
      <span className="confidence-icon">{getConfidenceIcon()}</span>
      <span className="confidence-text">
        Data completeness: {getCompletenessLabel()}
      </span>
      {showPercentage && (
        <span className="confidence-percentage">
          {confidence.percentage}%
        </span>
      )}
    </div>
  );
};

export default ConfidenceBadge;
